// EXPERIMENT #171270395

import IntercomUtils from '../../intercom_utils';
import {
  getAnswersFromStorage,
  storeAnswerToStorage,
  clearAnswersInStorage,
} from './storage_helpers';

const getTierFromURL = url => {
  const currentQueryParams = Object.fromEntries(new URL(url).searchParams);
  return currentQueryParams.tier;
};

const getTierSourceFromURL = url => {
  const currentQueryParams = Object.fromEntries(new URL(url).searchParams);
  return currentQueryParams.tier_source;
};

const resetWorkerTypeAnswer = surveyAnswers => {
  clearAnswersInStorage();
  storeAnswerToStorage('RUN_PAYROLL', surveyAnswers.RUN_PAYROLL);
  storeAnswerToStorage('PREV_PAYROLL_PROVIDER', surveyAnswers.PREV_PAYROLL_PROVIDER);
  storeAnswerToStorage('hasInteractedWithSurvey', surveyAnswers.hasInteractedWithSurvey);
};

const storeTierParamsInStorage = url => {
  const tier = getTierFromURL(url);

  if (!tier) {
    storeAnswerToStorage('tier', '');
    storeAnswerToStorage('tier_source', '');
    return;
  }

  // If tier is contractor_only, overrride any previous answer
  // and act as if the answer to the first question is contractor_only
  const surveyAnswers = getAnswersFromStorage();

  if (tier === 'contractor_only') {
    resetWorkerTypeAnswer(surveyAnswers);
    storeAnswerToStorage('WORKERS_TYPE', 'contractor_only');
  } else if (surveyAnswers.WORKERS_TYPE === 'contractor_only') {
    resetWorkerTypeAnswer(surveyAnswers);
  }

  storeAnswerToStorage('tier', tier);
  storeAnswerToStorage('tier_source', getTierSourceFromURL(url));
};

const getStoredCompanyLead = () => {
  const surveyAnswers = getAnswersFromStorage();
  return surveyAnswers.companyLead || {};
};

const rerender = (fromGoogleSSO, showModal) => {
  const reactOnRails = window.ReactOnRails;
  const companyLead = getStoredCompanyLead();
  if (reactOnRails) {
    reactOnRails.render(
      'SurveySignupModal',
      { fromGoogleSSO, companyLead, renderSurvey: showModal },
      'survey-signup-modal'
    );
  }
};

const toggleModalVisibility = (url, fromGoogleSSO) => {
  const signupModal = document.querySelector('#survey-signup-modal-wrapper.modal-wrapper');
  const blurrable = document.querySelector('#blurrable');
  if (signupModal && blurrable) {
    const modalClasses = signupModal.classList;
    const willShowModal = modalClasses.contains('hide');
    const fromGoogleSSOVal = fromGoogleSSO || false;
    if (url && willShowModal) {
      // If coming from GoogleSSO, don't override tier saved in session
      if (!fromGoogleSSO) {
        storeTierParamsInStorage(url);
      }
    }

    rerender(fromGoogleSSOVal, willShowModal);
    IntercomUtils.setLauncherVisibility(!willShowModal);

    modalClasses.toggle('hide');
    blurrable.classList.toggle('blurry');
    document.body.classList.toggle('nonscrollable');

    GustoAnalytics.track({
      eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
      eventName: 'SurveySignupModalToggleVisibility',
      data: { hidden: !willShowModal },
    });
  }
};

export default toggleModalVisibility;
